import { AccordionPanel as ChakraAccordionPanel } from '@chakra-ui/react';

type AccordionPanelProps = React.ComponentProps<typeof ChakraAccordionPanel>;

const AccordionPanel = ({
  children,
  ...props
}: Readonly<AccordionPanelProps>) => {
  return <ChakraAccordionPanel {...props}>{children}</ChakraAccordionPanel>;
};

export default AccordionPanel;
